<div class="mce-image-outer"
  [class.mce-image-selected]="selected()"
  [ngClass]="'mce-layout-' + layout">
  <div *ngIf="selected()" class="mce-image-toolbar" (mousedown)="onToolbarMouseDown($event)">
    <button type="button" class="mce-drag-button" data-drag-handle title="Drag to move">
      <mat-icon>drag_indicator</mat-icon>
    </button>
    <span class="mce-toolbar-separator"></span>
    <button type="button" [class.active]="showCaption" (mousedown)="toggleCaption($event)" title="Toggle caption">
      <mat-icon>closed_caption</mat-icon>
    </button>
    <span class="mce-toolbar-separator"></span>
    <button type="button" [class.active]="layout === 'centered'" (mousedown)="setLayout('centered', $event)" title="Centred">
      <mat-icon>image</mat-icon>
    </button>
    <button type="button" [class.active]="layout === 'float-left'" (mousedown)="setLayout('float-left', $event)" title="Float left">
      <mat-icon fontSet="material-symbols-outlined">format_image_inline_left</mat-icon>
    </button>
    <button type="button" [class.active]="layout === 'float-right'" (mousedown)="setLayout('float-right', $event)" title="Float right">
      <mat-icon fontSet="material-symbols-outlined">format_image_inline_right</mat-icon>
    </button>
  </div>
  <div class="mce-image-wrapper">
    <img [src]="src" [style.width]="width" (load)="onImageLoad($event)" draggable="false" />
    <span *ngIf="selected()" class="mce-resize-handle" (mousedown)="onHandleMousedown($event)"></span>
  </div>
  <div *ngIf="showCaption" class="mce-caption-wrapper">
    <input class="mce-caption-input" type="text" [value]="caption" (input)="onCaptionInput($event)" (keydown)="onCaptionKeydown($event)" placeholder="Enter image caption" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
  </div>
</div>
